import axios from 'axios';

export default {
  state: {
    listOfSpecies: [],
    currentSpecies: '',
    currentSpeciesLabel: '',
  },
  getters: {
    getCurrentSpecies: state => state.currentSpecies,
    getCurrentSpeciesLabel: state => state.currentSpeciesLabel,
    getListOfSpecies: state => state.listOfSpecies,
    getSpeciesLabel(state) {
      return id => {
        if (state.listOfSpecies.length > 0) {
          var species = state.listOfSpecies.find(s => s.id == id);
          if (species) return species.label;
          return '';
        }
        return '';
      };
    },
    getSpecies(state) {
      return id => {
        return state.listOfSpecies.find(s => s.id == id);
      };
    },
  },
  mutations: {
    setListOfSpecies(state, l) {
      state.listOfSpecies = l;
    },
    setCurrentSpecies(state, id) {
      state.currentSpecies = id;
      // update the species label
      if (state.listOfSpecies.length > 0) {
        var species = state.listOfSpecies.find(s => s.id == id);
        if (species) state.currentSpeciesLabel = species.label;
      }
    },
  },
  actions: {
    fetchListOfSpecies({ commit, rootGetters }) {
      const baseMessage = 'Error during fetching list of species';
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.getUrlBase + 'species')
          .then(
            resp => {
              if (resp.data.error === true) {
                commit('setErrored', true, { root: true });
                let message = resp.data.message
                  ? baseMessage + ': ' + resp.data.message
                  : baseMessage;
                commit('setErrorMsg', message, { root: true });
              } else {
                commit('setListOfSpecies', resp.data);
              }
              resolve(resp);
            },
            err => {
              console.log(err.response.data);
              let message = err.response.data.message
                ? baseMessage + ': ' + err.response.data.message
                : baseMessage;
              commit('setErrored', true, { root: true });
              commit('setErrorMsg', message, { root: true });
              reject(err);
            }
          )
          .catch(() => {
            commit('setErrored', true, { root: true });
            commit('setErrorMsg', baseMessage, { root: true });
          });
      });
    },
  },
};
